/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class FormSection extends BaseEntity implements Wars.Domain.Model.FormSection {
        constructor() {
            super();
            //this.expressionParts = [];
        }

        public splitFields: Wars.Domain.Model.Field[][];

        isVisible: boolean;
        position: number;
        formStep_id: string;
        description: string;
        form_id:string;
        condition_id: string;
        condition: Wars.Domain.Model.Conditions.Condition;
        readonlyCondition_id: string;
        readonlyCondition: Wars.Domain.Model.Conditions.Condition;
        objectSchema_id: string;
        SystemLevelListSchemaProperty_id: string;
        objectSchema: Wars.Domain.Model.ObjectSchema;
        fields: Wars.Domain.Model.Field[];
        securityMatrix_id: string;
        securityMatrix: Wars.Domain.Model.SecurityMatrix;
        systemLevelListSchemaProperty: Wars.Domain.Model.SchemaProperty;
        form: Wars.Domain.Model.Form;
        columns: Wars.Domain.Model.FormGridColumn[];
        formSectionDisplayType: Wars.Domain.Model.Codes.Enums.FormSectionDisplayType;
        formSectionType: Wars.Domain.Model.Codes.Enums.FormSectionType;
    }
}